import { MEDIA } from "@bridgesplit/ui";

export const VAULT_DETAIL_QUERY = MEDIA.LG;
